import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { forwardRef } from 'react';
import { Button } from '../../atoms';
import { Tag } from '../../molecules';
import { useTheme } from '../../theme';
import { getElementsOfType } from '../../utils/getElementsOfType';
export const DataTableFooter = forwardRef(function DataTableFooter({ children }, ref) {
    const theme = useTheme();
    const tags = getElementsOfType(children, Tag);
    const buttons = getElementsOfType(children, Button);
    return (_jsxs(Stack, { padding: theme.spacing(105, 0), ref: ref, direction: "row", justifyContent: "space-between", children: [_jsx(Stack, { direction: "row", gap: 109, children: tags }), _jsx(Stack, { direction: "row", gap: 109, children: buttons })] }));
});
